<template>
  <check-base-layout
    :pagetitle="pagetitle"
    :check-info-data="checkFrom"
  >
    <template>
      <div>
        <customer-module :customer-data="checkFrom.customerAccountCreditVo"></customer-module>
      </div>
      <check-module :title="`开票信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">合同编号：{{orderInvoiceContentStateVo.contractCode}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">开票编号：{{orderInvoiceContentStateVo.megerCode}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">开票金额：{{orderInvoiceContentStateVo.amount | toFixed}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="pb20">开票类型：{{orderInvoiceContentStateVo.bilingType}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">发票类型：{{orderInvoiceContentStateVo.invoiceType}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">税率：{{orderInvoiceContentStateVo.taxAmountCommit | toPercentFormat}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="pb20">公司名称：{{orderInvoiceContentStateVo.cusName}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">税号：{{orderInvoiceContentStateVo.taxNumber}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">银行账号：{{orderInvoiceContentStateVo.bankNumber}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="">开票地址：{{orderInvoiceContentStateVo.invoiceAddress}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">开户行：{{orderInvoiceContentStateVo.bankOpen}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">开票电话：{{orderInvoiceContentStateVo.invoicePhone}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`收票信息`">
        <el-row>
          <el-col :span="8">
            <div class="">收票人：{{orderInvoiceContentStateVo.receivePeople}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">收票地址：{{orderInvoiceContentStateVo.receiveAddress}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">联系电话：{{orderInvoiceContentStateVo.receivePhone}}</div>
          </el-col>
        </el-row>
      </check-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'
export default {
  name: 'fineMakeinvoiceCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '罚没金开票审批'
    }
  },
  computed: {
    // 开票信息
    orderInvoiceContentStateVo () {
      return this.checkFrom.orderInvoiceContentStateVo || {}
    },
    // 开票清单
    orderContractInvoiceStateVoList () {
      return this.checkFrom.orderInvoiceContentStateVo.orderContractInvoiceStateVoList || []
    }
  },
  mounted () {
    const { snaId } = this
    checkApi.getMakeinvoiceCheckInfo({
      snaId
    }).then(res => {
      if (isSuccess(res)) {
        this.checkFrom = res.data.obj
        this.$emit('update:data', deepClone(res.data.obj))
      } else {
        this.$message.error(res.data.msg)
      }
    })
  },
  data () {
    return {
      checkFrom: {
        orderInvoiceContentStateVo: {}
      }
    }
  }
}
</script>

<style scoped>

</style>
